module.exports = __webpack_public_path__ + "img/item5-2.55bb6e88.jpg";